module.exports = __webpack_public_path__ + "img/Element_extraction-6.9da8ddf4.jpg";